import styled from 'styled-components';
import { StyledText } from '@leasequery/lq.react-component-library';

const FooterTextBar = styled(StyledText)`
  display: flex;

  > svg {
    margin-left: auto;
  }
`;

export { FooterTextBar };
